export function directifyPadding(padding: [number, number, number, number], rtl: boolean): [number, number, number, number] {
  const [top, right, bottom, left] = padding;
  return rtl ? [top, left, bottom, right] : padding;
}
